import { useEffect, useRef } from 'react';

const SOUNDS_PATH = '/soundscrm/';
const SOUND_MAP = {
  save: `${SOUNDS_PATH}sfx-menu6.mp3`,        // Positive confirm
  delete: `${SOUNDS_PATH}sfx-menu17.mp3`,     // Alert/warning
  email: `${SOUNDS_PATH}sfx-menu11.mp3`,      // Email notification
  upload: `${SOUNDS_PATH}sfx-menu11.mp3`,     // Quick success
  quickadd: `${SOUNDS_PATH}sfx-menu20.mp3`,   // Add item
  pdf: `${SOUNDS_PATH}sfx-menu23.mp3`,        // Export/document
  exportzip: `${SOUNDS_PATH}sfx-menu20.mp3`,  // ZIP batch start
  ai: `${SOUNDS_PATH}sfx-menu9.mp3`           // AI analysis start
};


const audioCache = new Map();

export const preloadSounds = () => {
  Object.values(SOUND_MAP).forEach(path => {
    const audio = new Audio(path);
    audio.volume = 0.3;
    audio.preload = 'auto';
    audioCache.set(path, audio);
  });
};

export const playSound = (action) => {
  const path = SOUND_MAP[action];
  if (!path) return;

  const audio = audioCache.get(path) || new Audio(path);
  audio.volume = 0.3;
  audio.play().catch(e => console.log('Audio play failed (user gesture?):', e));
};

// Hook for components
export const useSoundPlayer = () => {
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      preloadSounds();
      initialized.current = true;
    }
  }, []);

  return { playSound };
};
